module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "md12": "",
      "mb-4": ""
    }
  }, [_c('div', {
    staticClass: "mod-name"
  }, [_c('p', {
    staticClass: "font-red"
  }, [_vm._v(_vm._s(_vm.temaName))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c2f047e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Nombretema.vue
// module id = 1043
// module chunks = 1